import { render, staticRenderFns } from "./foot-bottom.vue?vue&type=template&id=8b8da318&scoped=true&"
import script from "./foot-bottom.vue?vue&type=script&lang=js&"
export * from "./foot-bottom.vue?vue&type=script&lang=js&"
import style0 from "./foot-bottom.vue?vue&type=style&index=0&id=8b8da318&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8da318",
  null
  
)

export default component.exports